import React from "react"
import { Route, IndexRoute } from "react-router"

//ticketing components
import Index from "../components/common/Support/Index"
import SupportTicketListContainer from "../components/common/Support/SupportTicketListContainer"
import ViewSupportTicketContainer from "../components/common/Support/ViewSupportTicketContainer"
import AddSuppotTicket from "../components/common/Support/AddSupportTicket"

export const ticketingRoutes = (
  <Route path="support" component={Index}>
    <IndexRoute component={SupportTicketListContainer} />
    <Route path="ticket/add" component={AddSuppotTicket} />
    <Route path="ticket/:ticket_code" component={ViewSupportTicketContainer} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes/ticketingRoutes.js